import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import { ClientAddNavigationTrigger, ClientAddButtonTrigger } from './ClientAddTrigger'

const ClientAddFormModal = Loadable(() => import('./ClientAdd'))

export const CLIENT_ADD_NAVIGATION_MODAL = 'CLIENT_ADD_NAVIGATION_MODAL'

export const createClientAddNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'client_add',
  text: translateFn('mnu_client_add'),
  identity: CLIENT_ADD_NAVIGATION_MODAL,
  component: ClientAddFormModal,
}))

export { ClientAddNavigationTrigger, ClientAddButtonTrigger }

export default ClientAddFormModal
